var modules_3e23959b = {"container":"FooterLinks_module_container__f2e9cc40"};
import "../../../assets/BeQ3A8sf.css";

export { modules_3e23959b as default };
//# sourceMappingURL=FooterLinks.module.less.js.map
